import { useQuery } from "@tanstack/react-query"
import { getService } from "hooks/useStartup"

import { FetchClient } from "@/core/client/fetch_client"
import { StatusCode } from "@/core/generated/api/enums/status_code"
import { ResponseModel } from "@/core/generated/api/models/response_model"
import { ResponseSerializer } from "@/core/generated/api/response_serializer"
import { SpaceUserContext } from "../models/spaceUserContext"

const getSpaceUserContext = async (): Promise<SpaceUserContext | null> => {
  const client: FetchClient = getService(FetchClient)
  const response = (await client.getAsync(
    "/nxt/auth/me",
  )) as ResponseModel | null

  if (response?.code !== StatusCode.Ok) return null

  return ResponseSerializer.deserialize<SpaceUserContext>(response)
}

export const useSpaceUserContext = (spaceId: string | undefined) => {
  return useQuery<SpaceUserContext | null>({
    queryKey: ["auth/me", spaceId],
    queryFn: getSpaceUserContext,
    enabled: Boolean(spaceId),
    staleTime: 5 * 60 * 1000,
  })
}
